<template>
  <div class="main_right elevator_authorize_page">
    <breadcrumb :breadcrumb="config.breadcrumb" />
    <div class="authorize">
      <div class="elevator_box">
        <div v-for="liftDevice in liftDeviceList" :class="currentElevator === liftDevice.code ? 'elevator_item_current' : 'elevator_item'" @click="changeElevator(liftDevice.code)">
          <i class="el-icon-damai-dianti1"></i>
          <span>{{liftDevice.name}}</span>
        </div>
      </div>

      <div class="person_box">
        <div class="search-line">
          <button-add value="限制人员" @click="toElevatorBlackListAddPage" v-if="permissionCodes.indexOf('009004001') !== -1"/>
          <input-search v-model="searchKey" placeholder="姓名" @search="search"/>
        </div>
        <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" :total="total" :pageNum="pageNum" :pageSize="pageSize" :operationArr="operationArr" @changeSelection="changeSelection" @changePagination="changePagination" @deleteLine="deleteLine" />
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import api from "../../api/LadderControl";
import { errorHandler } from "../../../utils/errorHandler";
import TableMain from "../../../components/Table/TableMain";
import ButtonAdd from "../../../components/common/buttons/button-add";
import InputSearch from "../../../components/Input/InputSearch";
import { nSuccess } from "../../../utils/notice";
import { bus } from "../../../utils/bus";

export default {
  components: {
    InputSearch,
    ButtonAdd,
    TableMain,
    Breadcrumb
  },
  name: "elevator-authorize",
  data() {
    return {
      config: {
        breadcrumb: [
          {
            value: "智慧梯控",
            name: "ladder-device"
          },
          {
            value: "限制乘梯"
          }
        ]
      },
      addRouterName: "authorize-add",
      currentElevator: "",
      permissionCodes: "",
      total: 0,
      pageSize: 10,
      pageNum: 1,
      searchKey: "",
      liftDeviceList: [],
      operationArr: ["delete"],
      tableHead: [
        {
          prop: "personName",
          label: "人员姓名"
        },
        {
          prop: "enterpriseName",
          label: "住户名称"
        }
      ],
      tableData: []
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
    this.getLiftDeviceList();
  },
  activated() {
    this.getLiftDeviceList();
  },
  methods: {
    // 获取电梯列表
    getLiftDeviceList() {
      api
        .getLiftDeviceList()
        .then(data => {
          this.liftDeviceList = data;
          if (data.length > 0) {
            this.currentElevator = data[0].code;
            this.getLiftBlackAuthorityPage();
          }
        })
        .catch(errorHandler("获取电梯列表失败"));
    },
    // 获取授权人员列表
    getLiftBlackAuthorityPage() {
      api
        .getLiftBlackAuthorityPage({
          pageSize: this.pageSize,
          pageNum: this.pageNum,
          searchKey: this.searchKey,
          liftDeviceCode: this.currentElevator
        })
        .then(data => {
          this.total = data.total;
          this.tableData = data.list;
        })
        .catch(errorHandler("获取授权人员列表失败"));
    },
    // searchKey (v) {
    //   this.pageNum = 1
    //   this.requestData.searchKey = v
    //   this.getLiftBlackAuthorityPage()
    // },
    search(v) {
      this.pageNum = 1;
      this.searchKey = v;
      this.getLiftBlackAuthorityPage();
    },
    changePagination(data) {
      this.pageNum = data[0];
      this.pageSize = data[1];
      this.getLiftBlackAuthorityPage();
    },
    changeSelection(codeArr) {
      this.selectionArr = codeArr;
    },
    // 换电梯
    changeElevator(code) {
      this.currentElevator = code;
      this.pageNum = 1;
      this.getLiftBlackAuthorityPage();
    },

    // 授权添加页面
    toElevatorBlackListAddPage() {
      this.$router.push({
        name: "elevator-black-list-add"
      });
    },

    // 删除
    deleteLine(code) {
      api
        .deleteLiftBlackAuthorityByCodes(code)
        .then(data => {
          nSuccess("删除成功");
          this.getLiftBlackAuthorityPage();
        })
        .catch(errorHandler("删除失败"));
    }
  }
};
</script>

<style lang="less">
.elevator_authorize_page {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  .authorize {
    flex: 1;
    display: flex;
    justify-content: space-between;
    .elevator_box {
      width: 20%;
      height: 100%;
      border-left: 1px solid #eeeeee;
      border-right: 1px solid #eeeeee;
      .el-icon-damai-dianti1 {
        font-size: 30px;
      }
      .elevator_item {
        line-height: 60px;
        border-bottom: 1px solid #eeeeee;
        display: flex;
        justify-content: flex-start;
        justify-items: center;
        padding: 0 10px;
        i {
          line-height: 60px;
        }
        &:hover {
          cursor: pointer;
          background-color: #ecf5ff;
        }
      }
      .elevator_item_current {
        line-height: 60px;
        border-bottom: 1px solid #eeeeee;
        display: flex;
        justify-content: flex-start;
        justify-items: center;
        padding: 0 10px;
        color: #00a0e6;
        background-color: #ecf5ff;
        i {
          line-height: 60px;
        }
      }
    }
    .person_box {
      width: 80%;
      padding: 20px 10px;
      .search-line {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 10px;
        margin-bottom: 20px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/LadderControl/ElevatorBlackList/ElevatorBlackList.vue